import React from 'react';
import { formatTime } from '../../../../../utils/render';
import Time from './Time/Time';
import StatisticInfo from './StatisticsInfo/StatisticsInfo';
import BookedBadge from '../../../BookedBadge/BookedBadge';
import useGoalBadge from '../../../../../hooks/useGoalBadge';

import styles from './Statistics.module.scss';

const Statistics = ({ statistics, startedAt, isLive, isBooked }) => {
    let {
        homeTeamScore,
        awayTeamScore,
        homeTeamCurrentPeriodScore,
        awayTeamCurrentPeriodScore,
        eventTime,
        remainingTimeInPeriod,
        stoppageTime,
    } = statistics || {};

    const formattedEventTime = formatTime(eventTime);
    const formattedRemainingTime = formatTime(remainingTimeInPeriod);
    const formattedStoppageTime = formatTime(stoppageTime);

    const showHomeGoalBadge = useGoalBadge(homeTeamScore);
    const showAwayGoalBadge = useGoalBadge(awayTeamScore);

    const hasEventStarted =
        statistics && Object.keys(statistics).length && statistics.matchStatusCode && statistics.matchStatusCode !== 0;

    return (
        <td align='right'>
            <div className={'flex align-center justify-end'}>
                <BookedBadge isBooked={isBooked} isLive={isLive} />
                <div className={styles.timeGeneral}>
                    {hasEventStarted ? <StatisticInfo statistics={statistics} /> : <Time startedAt={startedAt} />}
                </div>
                {hasEventStarted ? (
                    <>
                        <div className={styles.timeSpecific}>
                            <span>{formattedRemainingTime || formattedEventTime}</span>
                            {formattedStoppageTime ? (
                                <span className={styles.stoppageTime}>+{formattedStoppageTime}</span>
                            ) : null}
                        </div>
                        <div className={styles.totalScore}>
                            <div className={showHomeGoalBadge ? styles.pulse : ''}>{homeTeamScore}</div>
                            <div className={showAwayGoalBadge ? styles.pulse : ''}>{awayTeamScore}</div>
                        </div>
                        <div className={styles.periodScore}>
                            <div>{homeTeamCurrentPeriodScore}</div>
                            <div>{awayTeamCurrentPeriodScore}</div>
                        </div>
                    </>
                ) : null}
            </div>
        </td>
    );
};

export default Statistics;
